import HttpStatusCode from '../../api/HttpStatusCode';

/**
 * Returns the HTTP status of a rejected request, or undefined when the error
 * carries no response status (e.g. a non-HTTP failure).
 */
function getHttpStatus(error: unknown): number | undefined {
  if (typeof error !== 'object' || error === null || !('response' in error)) return undefined;
  const { response } = error as { response: unknown };
  if (typeof response !== 'object' || response === null || !('status' in response))
    return undefined;
  const { status } = response as { status: unknown };
  return typeof status === 'number' ? status : undefined;
}

/**
 * True when a load failure means the viewer cannot see this content: a 403
 * (not authorized) or a 404 (missing). Both render the same not-found page so
 * that a forbidden item never reveals its existence to an unauthorized viewer.
 */
export function isNotFoundError(error: unknown): boolean {
  const status = getHttpStatus(error);
  return status === HttpStatusCode.Forbidden || status === HttpStatusCode.NotFound;
}
